import React from 'react';
import type { PathKey } from '../types/content';
interface PathSwitchProps {
  path: PathKey;
  onPathChange: (path: PathKey) => void;
  size?: 'sm' | 'md';
}
const options: Array<{
  key: PathKey;
  label: string;
}> = [{
  key: 'decouverte',
  label: 'Je découvre l’ULM'
}, {
  key: 'licencie',
  label: 'Je suis licencié'
}];
export function PathSwitch({
  path,
  onPathChange,
  size = 'md'
}: PathSwitchProps) {
  const pad = size === 'sm' ? 'px-3 py-1.5 text-[12px]' : 'px-5 py-2.5 text-[14px]';
  return <div role="tablist" aria-label="Choisir un parcours" className="inline-flex rounded-full border border-line bg-cloud p-1" data-id="element-200" data-mp="ohf5uu9lrzdy">
      {options.map(option => {
      const active = option.key === path;
      return <button key={option.key} type="button" role="tab" aria-selected={active} onClick={() => onPathChange(option.key)} className={`ffp-focus rounded-full font-semibold transition-colors duration-150 ease-soft ${pad} ${active ? 'bg-white text-ink shadow-sm' : 'text-ink/55 hover:text-ink'}`} data-id="element-201" data-mp="fn0q6ql5umub">
            {option.label}
          </button>;
    })}
    </div>;
}